import { render, staticRenderFns } from "./TopicModelStatisticsItem.vue?vue&type=template&id=754ff366&"
import script from "./TopicModelStatisticsItem.vue?vue&type=script&lang=js&"
export * from "./TopicModelStatisticsItem.vue?vue&type=script&lang=js&"
import style0 from "./TopicModelStatisticsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports